import React from 'react';
import TipTap from '../Sections/TipTap';
import { Divider, Input, List, message, Space, Typography } from 'antd';
import Title from 'antd/es/typography/Title';
import { ExclamationCircleFilled } from '@ant-design/icons';

interface SupplyAndDemandProps {
  data: any;
  setData: (path: string, value: any) => void;
  readonly?: boolean;
}

const SupplyAndDemand: React.FC<SupplyAndDemandProps> = ({ data, setData, readonly = false }) => {
  const handleChange = (path: string, value: any) => {
    if (readonly) return; // Prevent changes in readonly mode
    setData(path, value);
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Title level={5}>Trends</Title>
      <TipTap
        value={data.description}
        onChange={(value) => handleChange('supplyAndDemand.description', value)}
        readonly={readonly}
      />
      <Divider />
      <Space direction="vertical" style={{ flex: 1, width: '100%' }}>
        <Title level={5}>Issuance and retirement chart title</Title>
        <Input.TextArea
          value={data.issuanceAndRetirementText}
          onChange={(e) =>
            handleChange('supplyAndDemand.issuanceAndRetirementText', e.target.value)
          }
          placeholder="Enter issuance and retirement chart title here"
          disabled={readonly}
          style={{ marginBottom: '20px' }}
          maxLength={180}
          showCount
          rows={1}
          onKeyDown={(e) => {
            if (data.issuanceAndRetirementText.length >= 180 && e.key !== 'Backspace') {
              e.preventDefault();
            }
          }}
          onKeyUp={(e) => {
            if (data.issuanceAndRetirementText.length >= 180) {
              message.error('You have reached the maximum character limit');
            }
          }}
        />
        <Typography>
          If you want a citation on the title of the Issuance and retirement chart add the citation
          number here:
        </Typography>
        <Input
          value={data.issuanceAndRetirementCitations}
          placeholder="Enter super scripts here (appended at the end of title)"
          onChange={(e) =>
            handleChange('supplyAndDemand.issuanceAndRetirementCitations', e.target.value)
          }
          disabled={readonly}
        />
      </Space>
      <Space direction="vertical" style={{ flex: 1, width: '100%', marginTop: '20px' }}>
        <Title level={5}>Issuance and retirement chart takeaway (optional)</Title>

        <Input.TextArea
          value={data.issuanceAndRetirementTakeawayText}
          onChange={(e) =>
            handleChange('supplyAndDemand.issuanceAndRetirementTakeawayText', e.target.value)
          }
          placeholder="Enter issuance and retirement chart takeaway here"
          style={{ marginBottom: '20px' }}
          disabled={readonly}
          maxLength={180}
          showCount
          rows={3}
          onKeyDown={(e) => {
            if (data.issuanceAndRetirementTakeawayText.length >= 180 && e.key !== 'Backspace') {
              e.preventDefault();
            }
          }}
          onKeyUp={(e) => {
            if (data.issuanceAndRetirementTakeawayText.length >= 180) {
              message.error('You have reached the maximum character limit');
            }
          }}
        />
      </Space>
      <Divider />
      <Space direction="vertical" style={{ flex: 1, width: '100%' }}>
        <Title level={5}>Retirement percentage chart title </Title>

        <Input.TextArea
          value={data.returementPercentageText}
          onChange={(e) => handleChange('supplyAndDemand.returementPercentageText', e.target.value)}
          placeholder="Enter retirement percentage chart title here"
          style={{ marginBottom: '20px' }}
          disabled={readonly}
          maxLength={180}
          showCount
          rows={1}
          onKeyDown={(e) => {
            if (data.returementPercentageText.length >= 180 && e.key !== 'Backspace') {
              e.preventDefault();
            }
          }}
          onKeyUp={(e) => {
            if (data.returementPercentageText.length >= 180) {
              message.error('You have reached the maximum character limit');
            }
          }}
        />
        <Typography>
          If you want a citation on the title of the Retirements percentage chart add the citation
          number here:
        </Typography>
        <Input
          value={data.returementPercentageCitations}
          placeholder="Enter super scripts here (appended at the end of title)"
          onChange={(e) =>
            handleChange('supplyAndDemand.returementPercentageCitations', e.target.value)
          }
          disabled={readonly}
        />
      </Space>
      <Space direction="vertical" style={{ flex: 1, width: '100%', marginTop: '20px' }}>
        <Title level={5}>Retirement percentage chart takeaway here (optional)</Title>
        <Input.TextArea
          value={data.returementPercentageTakeawayText}
          onChange={(e) =>
            handleChange('supplyAndDemand.returementPercentageTakeawayText', e.target.value)
          }
          placeholder="Enter retirement percentage chart takeaway here"
          style={{ marginBottom: '20px' }}
          disabled={readonly}
          maxLength={180}
          showCount
          rows={3}
          onKeyDown={(e) => {
            if (data.returementPercentageTakeawayText.length >= 180 && e.key !== 'Backspace') {
              e.preventDefault();
            }
          }}
          onKeyUp={(e) => {
            if (data.returementPercentageTakeawayText.length >= 180) {
              message.error('You have reached the maximum character limit');
            }
          }}
        />
      </Space>
      <Divider />
      <Space direction="vertical" style={{ flex: 1, width: '100%' }}>
        <Title level={5}>Citation list (enter as a numbered list)</Title>
        <TipTap
          value={data.citations}
          onChange={(value) => handleChange('supplyAndDemand.citations', value)}
          readonly={readonly}
        />
      </Space>
    </Space>
  );
};

export default SupplyAndDemand;
